import moment from "moment";
import { MoreMenu } from "datastake-daf/dist/components";
import { camelCaseToTitle } from "../../../helpers/StringHelper";
import Tag from "antd/es/tag";
import { Tooltip } from "antd";

export const selectFiltersConfig = {};

export const filtersConfig = {
  datastakeId: '',
  name: '',
};

export const checkboxConfig = {
  datastakeId: 'ID',
  name: 'Name',
};

export const columnsConfig = ({
  t = (s) => s,
  goTo = () => { },
  namespace,
  mod,
  setSettingsVisible = () => { },
  options,
}) => [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'id',
      width: 160,
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }
        return item.datastakeId || item.id
      },
    },
    {
      title: t('Name'),
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }
        const label = v || '--'
        return <Tooltip title={label}>{label}</Tooltip>;
      },
    },
    {
      title: t('Category'),
      dataIndex: 'category',
      key: 'category',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        let label = '--'

        if (namespace === 'archives') {
          label = t(camelCaseToTitle(v || '--'));
        } else {
          const _options = (
            namespace === 'entities'
              ? options?.categoriesOptions
              : namespace === 'events' ? options?.eventsCategoryOptions
                : options?.locationCategory) || [];
          const val = (_options).find((val) => val.value === v);
          label = val?.label || v || '--'
        }

        return <Tooltip title={label}>{label}</Tooltip>;
      },
    },
    {
      title: t('Subcategory'),
      dataIndex: 'subCategory',
      key: 'subCategory',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        const _options = (options?.subCategoriesOptions) || [];
        const val = (_options).find((val) => val.value === v);
        const label = val?.label || v || '--'
        return <Tooltip title={label}>{label}</Tooltip>;
      },
    },
    {
      title: t('Country'),
      dataIndex: 'country',
      key: 'country',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        const val = (options?.countries || []).find((val) => val.value === v);
        const label = val?.label || v || '--'
        return <Tooltip title={label}>{label}</Tooltip>;
      },
    },
    {
      title: t('Sources'),
      dataIndex: 'source',
      key: 'source',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }
        const label = v ? v.name : '--'
        return <Tooltip title={label}>{label}</Tooltip>;
      },
    },
    {
      title: t('Ownership'),
      dataIndex: 'ownership',
      key: 'ownership',
      width: 110,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        switch (v) {
          case 'own':
            return <Tag color="blue">{t('Own')}</Tag>
          case 'acquired':
            return <Tag color="orange">{t('Acquired')}</Tag>
          default:
        }

        return '--';
      },
    },
    {
      title: t('DataStore::data-points'),
      dataIndex: 'totalDatapoints',
      key: 'totalDatapoints',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        const label = v || '--'
        return <Tooltip title={label}>{label}</Tooltip>;
      },
    },
    {
      title: t('Origin'),
      dataIndex: 'origin',
      key: 'origin',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        const label = v || '--'
        return <Tooltip title={label}>{label}</Tooltip>;
      },
    },
    {
      title: t('Last Update'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        const label = moment(v).format('DD MMM YYYY')
        return <Tooltip title={label}>{label}</Tooltip>;
      },
      ellipsis: true,
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      width: 60,
      render: (_, val) => {
        if (val.empty) {
          return <div className="daf-default-cell" />;
        }
        const items = [
          {
            key: "view",
            onClick: () => {
              goTo(`/app/${mod}/data-store/${namespace}/view/${val.datastakeId || val.id}`);
            },
            label: t('View Details'),
          },
          {
            key: "settings",
            onClick: () => {
              if (val.channels && val.channels[0]) {
                setSettingsVisible(val.channels[0]);
              }
            },
            label: t('Entity Settings'),
          },
        ]

        return <MoreMenu items={items} />;
      },
      ellipsis: true,
    },
  ]
